// import React, {useState} from 'react'
// import './Forgotpassword.css'
// import { validateEmail } from '../Utils/Validation';
// import { getAuth, sendPasswordResetEmail } from "firebase/auth";

// export default function Forgotpassword() {
  
//   const [email, setEmail] = useState('');
//   const [isEmailValid, setIsEmailValid] = useState(true);
//   const [message, setMessage] = useState('');

//   const handleEmailChange = (event) => {
//             validateEmail(event.target.value, setEmail, setIsEmailValid);
//           };


//   const handleForgotPassword = async (event) => {
//     event.preventDefault();
    
//     if (!isEmailValid || email === '') {
//       setMessage("Please enter a valid email.");
//       return;
//     }

//     const auth = getAuth();
//     try {
//       await sendPasswordResetEmail(auth, email);
//       setMessage("Reset link sent! Check your email.");
//     } catch (error) {
//       setMessage("Failed to send email. Try again.");
//     }
//   };

//   return (
//     <>
//       <div className='Forgot-Password-container'>
//           <form onSubmit={handleForgotPassword}>
//             <h2>Forgot Password.</h2>
//             <label>Enter register email address </label>
//             <div class="wrapper">
//               <i class="ri-mail-line" />
//               <input 
//               type='text'  
//                      name='email' 
//                      placeholder='john123@gmail.com' 
//                      value={email} 
//                      onChange={handleEmailChange} 
//                      required/>
//             </div>
//               {/* {!isEmailValid && email !== '' && (
//                 <div style={{ color: 'red', fontSize:'15px' }}>
//                   Email wrong formatting
//                 </div>
//               )}
//               {isEmailValid && email !== '' && (
//                 <div style={{ color: 'green', fontSize: '15px' }}>
//                   Excellent
//                 </div>
//               )} */}
//             {message && <div style={{ color: 'red', fontSize: '15px' }}>{message}</div>}
//             <button type="submit">Forgot Password</button>
//           </form>
//       </div>
//     </>
//   )
// }

import React, { useState } from 'react';
import './Authentication.css'; // Use the same CSS file as Login and Register
import { validateEmail } from '../Utils/Validation';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import InputField from './InputField'; // Import InputField component
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

export default function Forgotpassword() {
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [message, setMessage] = useState('');

  const handleEmailChange = (event) => {
    validateEmail(event.target.value, setEmail, setIsEmailValid);
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();

    if (!isEmailValid || email === '') {
      setMessage("Please enter a valid email.");
      return;
    }

    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Reset link sent! Check your email.");
    } catch (error) {
      setMessage("Failed to send email. Try again.");
    }
  };

  return (
    <div className="auth-container">
      <motion.div className="login-container"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <h2 className="form-title">Forgot Password</h2>
        <form onSubmit={handleForgotPassword} className="login-form">
          <InputField
            type="email"
            placeholder="Enter registered email address"
            icon="mail"
            value={email}
            onChange={handleEmailChange}
          />
          {/* {!isEmailValid && email !== '' && (
            <div style={{ color: 'red', fontSize: '15px' }}>
              Email wrong formatting
            </div>
          )}
          {isEmailValid && email !== '' && (
            <div style={{ color: 'green', fontSize: '15px' }}>
              Excellent
            </div>
          )}
          {message && (
            <div style={{ color: message.includes("Failed") ? 'red' : 'green', fontSize: '15px' }}>
              {message}
            </div>
          )} */}
          <button type="submit" className="login-button">
            Send Reset Link
          </button>
        </form>
        <p className="signup-prompt">
          Remember your password? <NavLink to="/login" className="signup-link">Login</NavLink>
        </p>
      </motion.div>
    </div>
  );
}